// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";
import AutogrowController from "./autogrow_controller";
application.register("autogrow", AutogrowController);

import CampaignSearchController from "./campaign_search_controller";
application.register("campaign-search", CampaignSearchController);

import ChartController from "./chart_controller";
application.register("chart", ChartController);

import ClipboardController from "./clipboard_controller";
application.register("clipboard", ClipboardController);

import ConsumerController from "./consumer_controller";
application.register("consumer", ConsumerController);

import DebuggerController from "./debugger_controller";
application.register("debugger", DebuggerController);

import DropdownPopoverController from "./dropdown_popover_controller";
application.register("dropdown-popover", DropdownPopoverController);

import FlashController from "./flash_controller";
application.register("flash", FlashController);

import FulfillmentInputController from "./fulfillment_input_controller";
application.register("fulfillment-input", FulfillmentInputController);

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import ModalController from "./modal_controller";
application.register("modal", ModalController);

import NewOrderFormController from "./new_order_form_controller";
application.register("new-order-form", NewOrderFormController);

import OnboardingFormController from "./onboarding_form_controller";
application.register("onboarding-form", OnboardingFormController);

import PaymentMethodInputController from "./payment_method_input_controller";
application.register("payment-method-input", PaymentMethodInputController);

import PaymentMethodsDescriptionController from "./payment_methods_description_controller";
application.register("payment-methods-description", PaymentMethodsDescriptionController);

import PopoverController from "./popover_controller";
application.register("popover", PopoverController);

import ProductInfoController from "./product_info_controller";
application.register("product-info", ProductInfoController);

import ProductItemCreateFormController from "./product_item_create_form_controller";
application.register("product-item-create-form", ProductItemCreateFormController);

import ProductItemEditQuantityFormController from "./product_item_edit_quantity_form_controller";
application.register("product-item-edit-quantity-form", ProductItemEditQuantityFormController);

import ProductSizesController from "./product_sizes_controller";
application.register("product-sizes", ProductSizesController);

import ProductVariantsController from "./product_variants_controller";
application.register("product-variants", ProductVariantsController);

import ReadMoreController from "./read_more_controller";
application.register("read-more", ReadMoreController);

import SearchController from "./search_controller";
application.register("search", SearchController);

import SelectController from "./select_controller";
application.register("select", SelectController);

import ShippingFieldsToggleController from "./shipping_fields_toggle_controller";
application.register("shipping-fields-toggle", ShippingFieldsToggleController);

import SlideoverController from "./slideover_controller";
application.register("slideover", SlideoverController);

import TooltipController from "./tooltip_controller";
application.register("tooltip", TooltipController);

import UploadController from "./upload_controller";
application.register("upload", UploadController);
